<ng-container *transloco="let t; prefix: 'tasks.taskDetail.products'">
  <div class="product-edit-dialog-content">
    <div class="product-edit-dialog-header">
      <span class="product-edit-dialog-title headline-small">
        {{ t('editDialog.productTitle') }}
      </span>
      <button
        matIconButton
        type="button"
        class="product-edit-dialog-close"
        [attr.aria-label]="t('editDialog.cancel')"
        [mat-dialog-close]="undefined">
        <i class="fa-regular fa-xmark" aria-hidden="true"></i>
      </button>
    </div>

    <div class="product-edit-dialog-body">
      <form class="product-edit-form" [formGroup]="editForm">
        <div class="product-heading-row">
          <div class="product-heading">
            <span class="title-large-emphasized">{{ item.descrizioneProdotto || '-' }}</span>
            <span class="body-small">
              {{ item.sku ?? item.codiceProdotto ?? '-' }}@if (item.nomeImballo) { - {{ item.nomeImballo }} {{ item.unitaFatturabile }} {{ item.unitaMisura }}}
            </span>
          </div>

          <div class="quantity-editor">
            @if (quantity > 1) {
              <button
                matIconButton
                type="button"
                class="quantity-action"
                [attr.aria-label]="t('editDialog.decreaseQuantity')"
                (click)="decreaseQuantity()">
                <i class="fa-regular fa-minus" aria-hidden="true"></i>
              </button>
            } @else {
              <button
                matIconButton
                type="button"
                class="quantity-action quantity-delete-action"
                [attr.aria-label]="t('editDialog.removeProduct')"
                (click)="deleteProduct()">
                <i class="fa-regular fa-trash-can" aria-hidden="true"></i>
              </button>
            }

            <span class="quantity-value body-medium-emphasized">{{ quantity }}</span>

            <button
              matIconButton
              type="button"
              class="quantity-action"
              [attr.aria-label]="t('editDialog.increaseQuantity')"
              (click)="increaseQuantity()">
              <i class="fa-regular fa-plus" aria-hidden="true"></i>
            </button>
          </div>
        </div>

        <div class="product-edit-fields">
          <mat-form-field appearance="outline" subscriptSizing="dynamic">
            <mat-label>{{ t('unitPrice') }}</mat-label>
            <input matInput type="number" step="0.0001" formControlName="prezzo">
            <span matTextSuffix class="field-unit">€@if (item.unitaMisura) {/{{ item.unitaMisura }}}</span>
            @if (fieldChanged('prezzo')) {
              <mat-hint align="end" class="original-value body-small">
                {{ t('editDialog.originalUnitPrice') }}:
                {{ item.prezzo | translocoCurrency: 'symbol' : {
                  useGrouping: true,
                  minimumFractionDigits: 4,
                  maximumFractionDigits: 4
                } : 'EUR' }}@if (item.unitaMisura) {/{{ item.unitaMisura }}}
              </mat-hint>
            }
          </mat-form-field>

          <mat-form-field appearance="outline" subscriptSizing="dynamic">
            <mat-label>{{ t('agentCommission') }}</mat-label>
            <input matInput type="number" step="0.01" formControlName="pProvvigione">
            <span matTextSuffix class="field-unit">%</span>
            @if (fieldChanged('pProvvigione')) {
              <mat-hint align="end" class="original-value body-small">
                {{ t('editDialog.originalAgentCommission') }}:
                {{ ((item.pProvvigione ?? 0) / 100) | translocoPercent: { minimumFractionDigits: 2, maximumFractionDigits: 2 } }}
              </mat-hint>
            }
          </mat-form-field>

          <mat-form-field appearance="outline" subscriptSizing="dynamic">
            <mat-label>{{ t('noProfit') }}</mat-label>
            <input matInput type="number" step="1" formControlName="pNoProfit">
            <span matTextSuffix class="field-unit">%</span>
            @if (fieldChanged('pNoProfit')) {
              <mat-hint align="end" class="original-value body-small">
                {{ t('editDialog.originalNoProfit') }}:
                {{ ((item.pNoProfit ?? 0) / 100) | translocoPercent: { minimumFractionDigits: 0, maximumFractionDigits: 0 } }}
              </mat-hint>
            }
          </mat-form-field>

          <mat-form-field appearance="outline" subscriptSizing="dynamic">
            <mat-label>{{ t('outOfBonus') }}</mat-label>
            <input matInput type="number" step="1" formControlName="pFuoriPremio">
            <span matTextSuffix class="field-unit">%</span>
            @if (fieldChanged('pFuoriPremio')) {
              <mat-hint align="end" class="original-value body-small">
                {{ t('editDialog.originalOutOfBonus') }}:
                {{ ((item.pFuoriPremio ?? 0) / 100) | translocoPercent: { minimumFractionDigits: 0, maximumFractionDigits: 0 } }}
              </mat-hint>
            }
          </mat-form-field>
        </div>
      </form>
    </div>
  </div>

  <div class="product-edit-dialog-footer">
    <div class="product-edit-dialog-actions">
      <button matButton type="button" [mat-dialog-close]="undefined">
        {{ t('editDialog.cancel') }}
      </button>
      <button
        matButton="filled"
        type="button"
        [disabled]="editForm.invalid || !hasChanges()"
        (click)="save()">
        {{ t('editDialog.save') }}
      </button>
    </div>
  </div>
</ng-container>
